import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NgMarkdownComponent } from '@mycicero/ng-markdown'
import { ButtonModule } from 'primeng/button'
import { FormElementsModule } from '../form-elements/form-elements.module'
import { ToastModule } from '../toast-module/toast'
import { ToastContainerComponent } from './toast-container/toast-container.component'

@NgModule({
  declarations: [ToastContainerComponent],
  imports: [CommonModule, ToastModule, ButtonModule, NgMarkdownComponent, FormElementsModule],
  exports: [ToastContainerComponent],
})
export class ToastExtensionModule {}
